<template>
  <div class="loading-screen">
    <div class="loading-content">
      <div class="spinner-container">
        <div class="spinner-grow text-primary" role="status"></div>
        <div class="spinner-grow text-primary ms-2" role="status" style="animation-delay: 0.2s"></div>
        <div class="spinner-grow text-primary ms-2" role="status" style="animation-delay: 0.4s"></div>
      </div>
      <h2 class="mt-4 text-primary">Caricamento in corso</h2>
      <p class="text-muted">Stiamo preparando il tuo backoffice...</p>
    </div>
    <div class="app-info">
      <p>Gestionale Pareri © 2025</p>
    </div>
  </div>
</template>

<script>
export default {
    name: 'LoadingView',
}
</script>

<style scoped>
.loading-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #f8f9fa;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-content {
    text-align: center;
    padding: 2rem;
    max-width: 500px;
}

.spinner-container {
    display: flex;
    justify-content: center;
}

.spinner-grow {
    width: 1.5rem;
    height: 1.5rem;
}

.app-info {
    position: absolute;
    bottom: 1rem;
    font-size: 0.8rem;
    color: #6c757d;
}

/* Animazione per il titolo */
h2 {
    animation: fadeIn 1s ease-in-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}
</style>
  